module.exports = __webpack_public_path__ + "42edbd50d27a8eebe967514aa0432448.pdf";